<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">EC企画商品一覧表</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">

        <div class="element-column">
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">受注コード</label>
              <div class="list-input-content">
                <app-order-code-text-input id="txi_OrderCode" #txi_OrderCode [subid]="'txi_OrderCode'"
                  [catalogIDField]="lbl_DelivCatalog" [forcedEnabledMode]="'true'" [tabindex]="0" [required]="true"
                  [autofocus]="true" [(ngModel)]="kymw5900Model.orderCode">
                </app-order-code-text-input>
              </div>

              <label class="list-input-title">配達企画回（翌週）</label>
              <div class="list-input-content">
                <input type="text" class="deliv-catalog" id="lbl_CatalogId" #lbl_DelivCatalog readonly>
              </div>

              <label class="list-input-title">登録商品</label>
              <div class="list-input-content">
                <app-code-combo-box id="cmb_EntryGoodsDiv" [subid]="'cmb_EntryGoodsDiv'" [codeDiv]="'ctp334'"
                  [blank]="true" [initFocusItem]="txi_OrderCode" [forcedEnabledMode]="'true'" [tabindex]="0"
                  [(ngModel)]="kymw5900Model.entryGoodsDiv" [width]="200"></app-code-combo-box>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title">部門</label>
              <div class="list-input-content">
                <app-class-code-combo-box id="cmb_ClassCode" [subid]="'cmb_ClassCode'" [forcedEnabledMode]="'true'"
                  [initFocusItem]="txi_OrderCode" [tabindex]="0" [width]="280"
                  [(ngModel)]="kymw5900Model.classCode"></app-class-code-combo-box>
              </div>

              <label class="list-input-title">媒体</label>
              <div class="list-input-content">
                <app-plan-medium-type-combo-box id="cmb_MediumType" [subid]="'cmb_MediumType'" [forcedEnabledMode]="'true'"
                  [initFocusItem]="txi_OrderCode" [tabindex]="0" [width]="280"
                  [(ngModel)]="kymw5900Model.mediumType"></app-plan-medium-type-combo-box>
              </div>
            </div>
          </div>

          <div class="column-list">
            <label class="list-input-title">会員生協</label>
            <div class="list-input-content">
              <app-checkbox-label label="全" id="chk_AllCoop" #chk_AllCoop
                [subid]="'chk_AllCoop'" layout="relative" [forcedEnabledMode]="'true'"
                [tabindex]="0" [(ngModel)]="kymw5900Model.allCoop"
                (change)="eventAllCoop_CHANGEHandler()"></app-checkbox-label>
              <app-checkbox-label label="い" id="chk_Ibaraki" #chk_Ibaraki
                [subid]="'chk_Ibaraki'" layout="relative" [forcedEnabledMode]="'true'"
                [tabindex]="0" [(ngModel)]="kymw5900Model.ibaraki"
                (change)="eventSeikyou_CLICKHandler()">
              </app-checkbox-label>
              <app-checkbox-label label="と" id="chk_Tochigi" #chk_Tochigi
                [subid]="'chk_Tochigi'" layout="relative" [forcedEnabledMode]="'true'"
                [tabindex]="0" [(ngModel)]="kymw5900Model.tochigi"
                (change)="eventSeikyou_CLICKHandler()">
              </app-checkbox-label>
              <app-checkbox-label label="ぐ" id="chk_Gunma" #chk_Gunma [subid]="'chk_Gunma'"
                layout="relative" [forcedEnabledMode]="'true'" [tabindex]="0"
                [(ngModel)]="kymw5900Model.gunma"
                (change)="eventSeikyou_CLICKHandler()">
              </app-checkbox-label>
              <app-checkbox-label label="ち" id="chk_Chiba" #chk_Chiba [subid]="'chk_Chiba'"
                layout="relative" [forcedEnabledMode]="'true'" [tabindex]="0"
                [(ngModel)]="kymw5900Model.chiba"
                (change)="eventSeikyou_CLICKHandler()">
              </app-checkbox-label>
              <app-checkbox-label label="さ" id="chk_Saitama" #chk_Saitama
                [subid]="'chk_Saitama'" layout="relative" [forcedEnabledMode]="'true'"
                [tabindex]="0" [(ngModel)]="kymw5900Model.saitama"
                (change)="eventSeikyou_CLICKHandler()">
              </app-checkbox-label>
              <app-checkbox-label label="とう" id="chk_Tokyo" #chk_Tokyo [subid]="'chk_Tokyo'"
                layout="relative" [forcedEnabledMode]="'true'" [tabindex]="0"
                [(ngModel)]="kymw5900Model.tokyo"
                (change)="eventSeikyou_CLICKHandler()">
              </app-checkbox-label>
              <app-checkbox-label label="な" id="chk_Nagano" #chk_Nagano
                [subid]="'chk_Nagano'" layout="relative" [forcedEnabledMode]="'true'"
                [tabindex]="0" [(ngModel)]="kymw5900Model.nagano"
                (change)="eventSeikyou_CLICKHandler()">
              </app-checkbox-label>
              <app-checkbox-label label="に" id="chk_Niigata" #chk_Niigata
                [subid]="'chk_Niigata'" layout="relative" [forcedEnabledMode]="'true'"
                [tabindex]="0" [(ngModel)]="kymw5900Model.niigata"
                (change)="eventSeikyou_CLICKHandler()">
              </app-checkbox-label>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Output" class="btn-primary" forcedEnabledMode="true" [tabindex]="0"
            (click)="eventCSVOut_CLICKHandler(lbl_DelivCatalog)">出力</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>